// Landing Page + Auth Page translations for 8 languages
const landingTranslations = {
  en: {
    // Nav
    nav_features: 'Features',
    nav_pricing: 'Pricing',
    nav_login: 'Login',
    nav_signup: 'Free Trial',
    // Hero
    hero_badge: 'New: Grab Integration + Accounting',
    hero_title_1: 'Your restaurant',
    hero_title_2: 'deserves better',
    hero_title_3: 'than a register',
    hero_desc: 'Smart POS with QR menu, real-time kitchen, integrated accounting and delivery integration. Everything your restaurant needs, in one app.',
    hero_cta: 'Start for free',
    hero_discover: 'Discover',
    stat_languages: 'Languages',
    stat_install: 'Setup',
    stat_commission: 'Commission',
    // Features
    features_title: 'All-in-one for your restaurant',
    features_subtitle: 'From digital menu to accounting, every feature is designed to simplify your daily operations.',
    feat_qr_title: 'Digital QR Menu',
    feat_qr_desc: 'Your customers scan, order and pay from their phone. 8 languages supported.',
    feat_pos_title: 'Touch Server POS',
    feat_pos_desc: 'Optimized for 15" touchscreens. Fast ordering, split bill, tips.',
    feat_kitchen_title: 'Kitchen & Bar',
    feat_kitchen_desc: 'Dual real-time screens. Kitchen and bar receive and validate independently.',
    feat_grab_title: 'Grab Integration',
    feat_grab_desc: 'Enter Grab orders directly. Automatic separate accounting.',
    feat_accounting_title: 'Accounting',
    feat_accounting_desc: 'Revenue, margins, tips, breakdown by source. CSV and PDF export for your accountant.',
    feat_lang_title: '8 Languages',
    feat_lang_desc: 'Menu automatically translated into English, French, Thai, Russian, German, Spanish, Arabic, Chinese.',
    feat_notif_title: 'Push Notifications',
    feat_notif_desc: 'Real-time alerts for servers, kitchen and customers when the order is ready.',
    feat_pay_title: 'Flexible Payments',
    feat_pay_desc: 'Cash, card, Stripe online. Split bill by item with change calculation.',
    // Steps
    steps_title: 'Up and running in 3 steps',
    step_1_title: 'Sign up',
    step_1_desc: 'Create your account and set up your restaurant in 2 minutes.',
    step_2_title: 'Add your menu',
    step_2_desc: 'Import your dishes, prices and photos. Automatic translation into 8 languages.',
    step_3_title: 'Start service',
    step_3_desc: 'Generate your QR codes, your servers connect and orders start flowing.',
    // Pricing
    pricing_title: 'Simple and transparent pricing',
    pricing_subtitle: '14-day free trial, no commitment.',
    popular_badge: 'Popular',
    plan_starter_name: 'Starter',
    plan_starter_desc: 'Ideal to get started',
    plan_pro_name: 'Pro',
    plan_pro_desc: 'For ambitious restaurants',
    plan_enterprise_name: 'Enterprise',
    plan_enterprise_desc: 'Complete solution without limits',
    plan_starter_cta: '14-day free trial',
    plan_pro_cta: '14-day free trial',
    plan_enterprise_cta: 'Contact us',
    plan_per_month: '/month',
    // Plan features
    pf_tables_5: '5 tables',
    pf_servers_2: '2 servers',
    pf_qr_menu: 'Digital QR menu',
    pf_realtime: 'Real-time orders',
    pf_cash_card: 'Cash & Card payment',
    pf_kitchen_bar: 'Kitchen & Bar',
    pf_email_support: 'Email support',
    pf_tables_20: '20 tables',
    pf_servers_10: '10 servers',
    pf_all_starter: 'All Starter +',
    pf_grab: 'Grab integration',
    pf_accounting: 'Accounting & CSV/PDF exports',
    pf_promo: 'Promo codes & Happy Hour',
    pf_loyalty: 'Loyalty program',
    pf_push: 'Push notifications',
    pf_priority_support: 'Priority support',
    pf_unlimited_tables: 'Unlimited tables',
    pf_unlimited_servers: 'Unlimited servers',
    pf_all_pro: 'All Pro +',
    pf_multi_restaurant: 'Multi-restaurant',
    pf_branding: 'Brand customization',
    pf_api: 'API access',
    pf_printer: 'Thermal printer',
    pf_onboarding: 'Dedicated onboarding',
    pf_247_support: '24/7 support',
    // Testimonial
    testimonial_text: '"We replaced Loyverse and we\'re not going back. The kitchen receives orders in real-time, servers are autonomous, and accounting is ready for our accountant every month."',
    testimonial_author: '— HIBISUN Restaurant, Phuket, Thailand',
    // CTA
    cta_title: 'Ready to modernize your restaurant?',
    cta_subtitle: '14-day free trial. No credit card required.',
    cta_btn: 'Start now',
    // Footer
    footer_secure: 'Secure & encrypted data',
    footer_terms: 'Terms of Sale',
    footer_terms_of_use: 'Terms of Use',
    footer_privacy: 'Privacy',
    footer_legal: 'Legal Notice',
    footer_contact: 'Contact',
    footer_company: 'INFINITY-GZ LLC — Sharjah Media City (SHAMS), UAE',
    // Auth Page
    auth_login_title: 'Login',
    auth_register_title: 'Create an account',
    auth_login_desc: 'Access your restaurant',
    auth_register_desc: 'Launch your restaurant in 2 minutes',
    auth_name_placeholder: 'Your name',
    auth_restaurant_placeholder: 'Restaurant name',
    auth_email_placeholder: 'Email',
    auth_password_placeholder: 'Password',
    auth_submit_login: 'Log in',
    auth_submit_register: 'Sign up',
    auth_or: 'or',
    auth_google: 'Continue with Google',
    auth_no_account: 'No account yet?',
    auth_has_account: 'Already have an account?',
    auth_signup_link: 'Sign up',
    auth_login_link: 'Log in',
    auth_fill_all: 'Fill in all fields',
    auth_success_login: 'Login successful!',
    auth_success_register: 'Account created successfully!',
    auth_error: 'Connection error',
    auth_google_soon: 'Google Login coming soon',
    auth_forgot_title: 'Forgot password',
    auth_forgot_desc: 'Enter your email and we will send you a reset link.',
    auth_forgot_link: 'Forgot password?',
    auth_forgot_submit: 'Send reset link',
    auth_reset_sent: 'If this email exists, a reset link has been sent.',
    auth_back_login: 'Back to login',
    auth_reset_title: 'New password',
    auth_reset_desc: 'Choose your new password.',
    auth_reset_new_password: 'New password',
    auth_reset_confirm_password: 'Confirm password',
    auth_reset_submit: 'Reset password',
    auth_reset_mismatch: 'Passwords do not match',
    auth_reset_min_length: 'Minimum 6 characters',
    auth_reset_success: 'Password changed successfully!',
    auth_reset_error: 'Invalid or expired link',
    auth_reset_invalid: 'Invalid reset link.',
    auth_reset_done_title: 'Password changed!',
    auth_reset_done_desc: 'You can now log in with your new password.',
    auth_referral_banner: 'You have been invited! Subscribe to get 1 free month for both of you.',
  },
  fr: {
    nav_features: 'Fonctionnalites',
    nav_pricing: 'Tarifs',
    nav_login: 'Connexion',
    nav_signup: 'Essai gratuit',
    hero_badge: 'Nouveau : Integration Grab + Comptabilite',
    hero_title_1: 'Votre restaurant',
    hero_title_2: 'merite mieux',
    hero_title_3: "qu'une caisse",
    hero_desc: 'POS intelligent avec menu QR, cuisine temps reel, comptabilite integree et integration livraison. Tout ce dont votre restaurant a besoin, en une seule application.',
    hero_cta: 'Commencer gratuitement',
    hero_discover: 'Decouvrir',
    stat_languages: 'Langues',
    stat_install: 'Installation',
    stat_commission: 'Commission',
    features_title: 'Tout-en-un pour votre restaurant',
    features_subtitle: 'Du menu digital a la comptabilite, chaque fonctionnalite est pensee pour simplifier votre quotidien.',
    feat_qr_title: 'Menu QR Digital',
    feat_qr_desc: 'Vos clients scannent, commandent et paient depuis leur telephone. 8 langues supportees.',
    feat_pos_title: 'POS Serveur Tactile',
    feat_pos_desc: 'Interface optimisee ecrans tactiles 15". Prise de commande rapide, split bill, pourboires.',
    feat_kitchen_title: 'Cuisine & Bar',
    feat_kitchen_desc: 'Double ecran temps reel. La cuisine et le bar recoivent et valident independamment.',
    feat_grab_title: 'Integration Grab',
    feat_grab_desc: 'Saisissez les commandes Grab directement. Comptabilite separee automatique.',
    feat_accounting_title: 'Comptabilite',
    feat_accounting_desc: 'CA, marges, pourboires, ventilation par source. Export CSV et PDF pour votre comptable.',
    feat_lang_title: '8 Langues',
    feat_lang_desc: 'Menu traduit automatiquement en anglais, francais, thai, russe, allemand, espagnol, arabe, chinois.',
    feat_notif_title: 'Notifications Push',
    feat_notif_desc: 'Alertes en temps reel pour les serveurs, la cuisine et les clients quand la commande est prete.',
    feat_pay_title: 'Paiements Flexibles',
    feat_pay_desc: 'Cash, carte bancaire, Stripe en ligne. Split bill par article avec calcul de monnaie.',
    steps_title: 'Operationnel en 3 etapes',
    step_1_title: 'Inscrivez-vous',
    step_1_desc: 'Creez votre compte et configurez votre restaurant en 2 minutes.',
    step_2_title: 'Ajoutez votre menu',
    step_2_desc: 'Importez vos plats, prix et photos. Traduction automatique en 8 langues.',
    step_3_title: 'Lancez le service',
    step_3_desc: 'Generez vos QR codes, vos serveurs se connectent et les commandes arrivent.',
    pricing_title: 'Des tarifs simples et transparents',
    pricing_subtitle: "14 jours d'essai gratuit, sans engagement.",
    popular_badge: 'Populaire',
    plan_starter_name: 'Starter',
    plan_starter_desc: 'Ideal pour demarrer',
    plan_pro_name: 'Pro',
    plan_pro_desc: 'Pour les restaurants ambitieux',
    plan_enterprise_name: 'Enterprise',
    plan_enterprise_desc: 'Solution complete sans limites',
    plan_starter_cta: 'Essai gratuit 14 jours',
    plan_pro_cta: 'Essai gratuit 14 jours',
    plan_enterprise_cta: 'Nous contacter',
    plan_per_month: '/mois',
    pf_tables_5: '5 tables',
    pf_servers_2: '2 serveurs',
    pf_qr_menu: 'Menu QR digital',
    pf_realtime: 'Commandes en temps reel',
    pf_cash_card: 'Paiement Cash & CB',
    pf_kitchen_bar: 'Cuisine & Bar',
    pf_email_support: 'Support email',
    pf_tables_20: '20 tables',
    pf_servers_10: '10 serveurs',
    pf_all_starter: 'Tout Starter +',
    pf_grab: 'Integration Grab',
    pf_accounting: 'Comptabilite & exports CSV/PDF',
    pf_promo: 'Codes promo & Happy Hour',
    pf_loyalty: 'Programme fidelite',
    pf_push: 'Notifications push',
    pf_priority_support: 'Support prioritaire',
    pf_unlimited_tables: 'Tables illimitees',
    pf_unlimited_servers: 'Serveurs illimites',
    pf_all_pro: 'Tout Pro +',
    pf_multi_restaurant: 'Multi-restaurant',
    pf_branding: 'Personnalisation marque',
    pf_api: 'API access',
    pf_printer: 'Imprimante thermique',
    pf_onboarding: 'Onboarding dedie',
    pf_247_support: 'Support 24/7',
    testimonial_text: '"On a remplace Loyverse et on ne revient pas en arriere. La cuisine recoit les commandes en temps reel, les serveurs sont autonomes, et la compta est prete pour notre comptable chaque mois."',
    testimonial_author: '— HIBISUN Restaurant, Phuket, Thailand',
    cta_title: 'Pret a moderniser votre restaurant ?',
    cta_subtitle: 'Essai gratuit de 14 jours. Aucune carte bancaire requise.',
    cta_btn: 'Commencer maintenant',
    footer_secure: 'Donnees securisees & chiffrees',
    footer_terms: 'CGV',
    footer_terms_of_use: 'CGU',
    footer_privacy: 'Confidentialite',
    footer_legal: 'Mentions legales',
    footer_contact: 'Contact',
    footer_company: 'INFINITY-GZ LLC — Sharjah Media City (SHAMS), UAE',
    auth_login_title: 'Connexion',
    auth_register_title: 'Creer un compte',
    auth_login_desc: 'Accedez a votre restaurant',
    auth_register_desc: 'Lancez votre restaurant en 2 minutes',
    auth_name_placeholder: 'Votre nom',
    auth_restaurant_placeholder: 'Nom du restaurant',
    auth_email_placeholder: 'Email',
    auth_password_placeholder: 'Mot de passe',
    auth_submit_login: 'Se connecter',
    auth_submit_register: "S'inscrire",
    auth_or: 'ou',
    auth_google: 'Continuer avec Google',
    auth_no_account: 'Pas encore de compte ?',
    auth_has_account: 'Deja un compte ?',
    auth_signup_link: "S'inscrire",
    auth_login_link: 'Se connecter',
    auth_fill_all: 'Remplissez tous les champs',
    auth_success_login: 'Connexion reussie !',
    auth_success_register: 'Compte cree avec succes !',
    auth_error: 'Erreur de connexion',
    auth_google_soon: 'Google Login sera disponible prochainement',
    auth_forgot_title: 'Mot de passe oublie',
    auth_forgot_desc: 'Entrez votre email, nous vous enverrons un lien de reinitialisation.',
    auth_forgot_link: 'Mot de passe oublie ?',
    auth_forgot_submit: 'Envoyer le lien',
    auth_reset_sent: 'Si cet email existe, un lien de reinitialisation a ete envoye.',
    auth_back_login: 'Retour a la connexion',
    auth_reset_title: 'Nouveau mot de passe',
    auth_reset_desc: 'Choisissez votre nouveau mot de passe.',
    auth_reset_new_password: 'Nouveau mot de passe',
    auth_reset_confirm_password: 'Confirmer le mot de passe',
    auth_reset_submit: 'Reinitialiser',
    auth_reset_mismatch: 'Les mots de passe ne correspondent pas',
    auth_reset_min_length: 'Minimum 6 caracteres',
    auth_reset_success: 'Mot de passe modifie avec succes !',
    auth_reset_error: 'Lien invalide ou expire',
    auth_reset_invalid: 'Lien de reinitialisation invalide.',
    auth_reset_done_title: 'Mot de passe modifie !',
    auth_reset_done_desc: 'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
    auth_referral_banner: 'Vous avez ete invite ! Souscrivez pour obtenir 1 mois gratuit pour vous deux.',
  },
  th: {
    nav_features: 'ฟีเจอร์',
    nav_pricing: 'ราคา',
    nav_login: 'เข้าสู่ระบบ',
    nav_signup: 'ทดลองฟรี',
    hero_badge: 'ใหม่: เชื่อมต่อ Grab + ระบบบัญชี',
    hero_title_1: 'ร้านอาหารของคุณ',
    hero_title_2: 'สมควรได้ดีกว่า',
    hero_title_3: 'แค่เครื่องคิดเงิน',
    hero_desc: 'POS อัจฉริยะพร้อมเมนู QR, ครัวเรียลไทม์, บัญชีในตัว และระบบจัดส่ง ทุกอย่างที่ร้านอาหารต้องการในแอปเดียว',
    hero_cta: 'เริ่มใช้ฟรี',
    hero_discover: 'เรียนรู้เพิ่มเติม',
    stat_languages: 'ภาษา',
    stat_install: 'ติดตั้ง',
    stat_commission: 'ค่าคอมมิชชั่น',
    features_title: 'ครบจบในแอปเดียว',
    features_subtitle: 'จากเมนูดิจิทัลถึงบัญชี ทุกฟีเจอร์ออกแบบมาเพื่อให้การทำงานง่ายขึ้น',
    feat_qr_title: 'เมนู QR ดิจิทัล',
    feat_qr_desc: 'ลูกค้าสแกน สั่ง และจ่ายเงินจากโทรศัพท์ รองรับ 8 ภาษา',
    feat_pos_title: 'POS หน้าจอสัมผัส',
    feat_pos_desc: 'ปรับแต่งสำหรับหน้าจอ 15 นิ้ว สั่งอาหารเร็ว แยกบิล ทิป',
    feat_kitchen_title: 'ครัว & บาร์',
    feat_kitchen_desc: 'หน้าจอคู่เรียลไทม์ ครัวและบาร์รับและยืนยันแยกกัน',
    feat_grab_title: 'เชื่อมต่อ Grab',
    feat_grab_desc: 'ป้อนคำสั่ง Grab โดยตรง บัญชีแยกอัตโนมัติ',
    feat_accounting_title: 'ระบบบัญชี',
    feat_accounting_desc: 'รายได้ กำไร ทิป แยกตามแหล่ง ส่งออก CSV และ PDF',
    feat_lang_title: '8 ภาษา',
    feat_lang_desc: 'เมนูแปลอัตโนมัติเป็นอังกฤษ ฝรั่งเศส ไทย รัสเซีย เยอรมัน สเปน อาหรับ จีน',
    feat_notif_title: 'การแจ้งเตือน Push',
    feat_notif_desc: 'แจ้งเตือนเรียลไทม์สำหรับพนักงาน ครัว และลูกค้าเมื่อออเดอร์พร้อม',
    feat_pay_title: 'ชำระเงินยืดหยุ่น',
    feat_pay_desc: 'เงินสด บัตร Stripe ออนไลน์ แยกบิลตามรายการพร้อมคำนวณทอน',
    steps_title: 'พร้อมใช้งานใน 3 ขั้นตอน',
    step_1_title: 'สมัครสมาชิก',
    step_1_desc: 'สร้างบัญชีและตั้งค่าร้านอาหารใน 2 นาที',
    step_2_title: 'เพิ่มเมนู',
    step_2_desc: 'นำเข้ารายการอาหาร ราคา และรูปภาพ แปลอัตโนมัติ 8 ภาษา',
    step_3_title: 'เริ่มให้บริการ',
    step_3_desc: 'สร้าง QR code พนักงานเชื่อมต่อ และออเดอร์เริ่มเข้า',
    pricing_title: 'ราคาที่เรียบง่ายและโปร่งใส',
    pricing_subtitle: 'ทดลองฟรี 14 วัน ไม่มีข้อผูกมัด',
    popular_badge: 'ยอดนิยม',
    plan_starter_name: 'Starter',
    plan_starter_desc: 'เหมาะสำหรับเริ่มต้น',
    plan_pro_name: 'Pro',
    plan_pro_desc: 'สำหรับร้านอาหารที่ต้องการเติบโต',
    plan_enterprise_name: 'Enterprise',
    plan_enterprise_desc: 'โซลูชั่นครบวงจร',
    plan_starter_cta: 'ทดลองฟรี 14 วัน',
    plan_pro_cta: 'ทดลองฟรี 14 วัน',
    plan_enterprise_cta: 'ติดต่อเรา',
    plan_per_month: '/เดือน',
    pf_tables_5: '5 โต๊ะ', pf_servers_2: '2 พนักงาน', pf_qr_menu: 'เมนู QR ดิจิทัล', pf_realtime: 'ออเดอร์เรียลไทม์', pf_cash_card: 'ชำระเงินสด & บัตร', pf_kitchen_bar: 'ครัว & บาร์', pf_email_support: 'สนับสนุนทางอีเมล',
    pf_tables_20: '20 โต๊ะ', pf_servers_10: '10 พนักงาน', pf_all_starter: 'ทุกอย่างใน Starter +', pf_grab: 'เชื่อมต่อ Grab', pf_accounting: 'บัญชี & ส่งออก CSV/PDF', pf_promo: 'โค้ดส่วนลด & Happy Hour', pf_loyalty: 'โปรแกรมสะสมคะแนน', pf_push: 'การแจ้งเตือน Push', pf_priority_support: 'สนับสนุนลำดับแรก',
    pf_unlimited_tables: 'โต๊ะไม่จำกัด', pf_unlimited_servers: 'พนักงานไม่จำกัด', pf_all_pro: 'ทุกอย่างใน Pro +', pf_multi_restaurant: 'หลายสาขา', pf_branding: 'ปรับแต่งแบรนด์', pf_api: 'API access', pf_printer: 'เครื่องพิมพ์ความร้อน', pf_onboarding: 'Onboarding เฉพาะ', pf_247_support: 'สนับสนุน 24/7',
    testimonial_text: '"เราเปลี่ยนจาก Loyverse แล้วไม่กลับไปอีก ครัวรับออเดอร์เรียลไทม์ พนักงานเป็นอิสระ และบัญชีพร้อมสำหรับนักบัญชีทุกเดือน"',
    testimonial_author: '— ร้านอาหาร HIBISUN, ภูเก็ต, ประเทศไทย',
    cta_title: 'พร้อมที่จะยกระดับร้านอาหารของคุณ?',
    cta_subtitle: 'ทดลองฟรี 14 วัน ไม่ต้องใช้บัตรเครดิต',
    cta_btn: 'เริ่มเลย',
    footer_secure: 'ข้อมูลปลอดภัยและเข้ารหัส',
    footer_terms: 'เงื่อนไขการขาย',
    footer_terms_of_use: 'เงื่อนไขการใช้',
    footer_privacy: 'ความเป็นส่วนตัว',
    footer_legal: 'ข้อมูลกฎหมาย',
    footer_contact: 'ติดต่อ',
    footer_company: 'INFINITY-GZ LLC — Sharjah Media City (SHAMS), UAE',
    auth_login_title: 'เข้าสู่ระบบ',
    auth_register_title: 'สร้างบัญชี',
    auth_login_desc: 'เข้าถึงร้านอาหารของคุณ',
    auth_register_desc: 'เปิดร้านอาหารใน 2 นาที',
    auth_name_placeholder: 'ชื่อของคุณ',
    auth_restaurant_placeholder: 'ชื่อร้านอาหาร',
    auth_email_placeholder: 'อีเมล',
    auth_password_placeholder: 'รหัสผ่าน',
    auth_submit_login: 'เข้าสู่ระบบ',
    auth_submit_register: 'สมัครสมาชิก',
    auth_or: 'หรือ',
    auth_google: 'ดำเนินการต่อด้วย Google',
    auth_no_account: 'ยังไม่มีบัญชี?',
    auth_has_account: 'มีบัญชีแล้ว?',
    auth_signup_link: 'สมัครสมาชิก',
    auth_login_link: 'เข้าสู่ระบบ',
    auth_fill_all: 'กรุณากรอกข้อมูลทั้งหมด',
    auth_success_login: 'เข้าสู่ระบบสำเร็จ!',
    auth_success_register: 'สร้างบัญชีสำเร็จ!',
    auth_error: 'เกิดข้อผิดพลาดในการเชื่อมต่อ',
    auth_google_soon: 'Google Login จะเปิดใช้เร็วๆ นี้',
    auth_forgot_title: 'ลืมรหัสผ่าน',
    auth_forgot_desc: 'กรอกอีเมลของคุณ เราจะส่งลิงก์รีเซ็ตให้',
    auth_forgot_link: 'ลืมรหัสผ่าน?',
    auth_forgot_submit: 'ส่งลิงก์รีเซ็ต',
    auth_reset_sent: 'หากอีเมลนี้มีอยู่ ลิงก์รีเซ็ตจะถูกส่งไปแล้ว',
    auth_back_login: 'กลับไปเข้าสู่ระบบ',
    auth_reset_title: 'รหัสผ่านใหม่',
    auth_reset_desc: 'เลือกรหัสผ่านใหม่ของคุณ',
    auth_reset_new_password: 'รหัสผ่านใหม่',
    auth_reset_confirm_password: 'ยืนยันรหัสผ่าน',
    auth_reset_submit: 'รีเซ็ตรหัสผ่าน',
    auth_reset_mismatch: 'รหัสผ่านไม่ตรงกัน',
    auth_reset_min_length: 'อย่างน้อย 6 ตัวอักษร',
    auth_reset_success: 'เปลี่ยนรหัสผ่านสำเร็จ!',
    auth_reset_error: 'ลิงก์ไม่ถูกต้องหรือหมดอายุ',
    auth_reset_invalid: 'ลิงก์รีเซ็ตไม่ถูกต้อง',
    auth_reset_done_title: 'เปลี่ยนรหัสผ่านแล้ว!',
    auth_reset_done_desc: 'คุณสามารถเข้าสู่ระบบด้วยรหัสผ่านใหม่ได้แล้ว',
    auth_referral_banner: 'คุณได้รับเชิญ! สมัครสมาชิกเพื่อรับ 1 เดือนฟรีสำหรับทั้งสองฝ่าย',
  },
  ru: {
    nav_features: 'Функции',
    nav_pricing: 'Цены',
    nav_login: 'Войти',
    nav_signup: 'Пробный период',
    hero_badge: 'Новое: Интеграция Grab + Бухгалтерия',
    hero_title_1: 'Ваш ресторан',
    hero_title_2: 'заслуживает лучшего',
    hero_title_3: 'чем просто касса',
    hero_desc: 'Умная POS с QR-меню, кухней в реальном времени, встроенной бухгалтерией и интеграцией доставки. Все, что нужно вашему ресторану.',
    hero_cta: 'Начать бесплатно',
    hero_discover: 'Узнать больше',
    stat_languages: 'Языков',
    stat_install: 'Установка',
    stat_commission: 'Комиссия',
    features_title: 'Все в одном для вашего ресторана',
    features_subtitle: 'От цифрового меню до бухгалтерии — каждая функция создана для упрощения работы.',
    feat_qr_title: 'Цифровое QR-меню',
    feat_qr_desc: 'Клиенты сканируют, заказывают и платят с телефона. 8 языков.',
    feat_pos_title: 'POS для официантов',
    feat_pos_desc: 'Оптимизировано для 15" тачскринов. Быстрые заказы, разделение счета, чаевые.',
    feat_kitchen_title: 'Кухня и Бар',
    feat_kitchen_desc: 'Двойной экран реального времени. Кухня и бар получают и подтверждают независимо.',
    feat_grab_title: 'Интеграция Grab',
    feat_grab_desc: 'Вводите заказы Grab напрямую. Автоматический раздельный учет.',
    feat_accounting_title: 'Бухгалтерия',
    feat_accounting_desc: 'Выручка, маржа, чаевые, разбивка по источникам. Экспорт CSV и PDF.',
    feat_lang_title: '8 Языков',
    feat_lang_desc: 'Меню автоматически переводится на 8 языков.',
    feat_notif_title: 'Push-уведомления',
    feat_notif_desc: 'Мгновенные уведомления для официантов, кухни и клиентов.',
    feat_pay_title: 'Гибкие платежи',
    feat_pay_desc: 'Наличные, карта, Stripe онлайн. Разделение по позициям.',
    steps_title: 'Запуск за 3 шага',
    step_1_title: 'Зарегистрируйтесь',
    step_1_desc: 'Создайте аккаунт и настройте ресторан за 2 минуты.',
    step_2_title: 'Добавьте меню',
    step_2_desc: 'Импортируйте блюда, цены и фото. Автоперевод на 8 языков.',
    step_3_title: 'Начните работу',
    step_3_desc: 'Сгенерируйте QR-коды, официанты подключатся и заказы пойдут.',
    pricing_title: 'Простые и прозрачные цены',
    pricing_subtitle: '14 дней бесплатно, без обязательств.',
    popular_badge: 'Популярный',
    plan_starter_name: 'Starter', plan_starter_desc: 'Идеально для старта',
    plan_pro_name: 'Pro', plan_pro_desc: 'Для амбициозных ресторанов',
    plan_enterprise_name: 'Enterprise', plan_enterprise_desc: 'Полное решение без ограничений',
    plan_starter_cta: '14 дней бесплатно', plan_pro_cta: '14 дней бесплатно', plan_enterprise_cta: 'Связаться с нами',
    plan_per_month: '/мес',
    pf_tables_5: '5 столов', pf_servers_2: '2 официанта', pf_qr_menu: 'QR-меню', pf_realtime: 'Заказы реального времени', pf_cash_card: 'Наличные & Карта', pf_kitchen_bar: 'Кухня & Бар', pf_email_support: 'Email поддержка',
    pf_tables_20: '20 столов', pf_servers_10: '10 официантов', pf_all_starter: 'Все из Starter +', pf_grab: 'Интеграция Grab', pf_accounting: 'Бухгалтерия & экспорт CSV/PDF', pf_promo: 'Промокоды & Happy Hour', pf_loyalty: 'Программа лояльности', pf_push: 'Push-уведомления', pf_priority_support: 'Приоритетная поддержка',
    pf_unlimited_tables: 'Безлимитные столы', pf_unlimited_servers: 'Безлимитные официанты', pf_all_pro: 'Все из Pro +', pf_multi_restaurant: 'Мульти-ресторан', pf_branding: 'Кастомизация бренда', pf_api: 'API доступ', pf_printer: 'Термопринтер', pf_onboarding: 'Онбординг', pf_247_support: 'Поддержка 24/7',
    testimonial_text: '"Мы заменили Loyverse и не возвращаемся. Кухня получает заказы в реальном времени, официанты автономны, бухгалтерия готова каждый месяц."',
    testimonial_author: '— Ресторан HIBISUN, Пхукет, Таиланд',
    cta_title: 'Готовы модернизировать ваш ресторан?',
    cta_subtitle: '14 дней бесплатно. Карта не нужна.',
    cta_btn: 'Начать сейчас',
    footer_secure: 'Защищенные и зашифрованные данные',
    footer_terms: 'Условия продажи',
    footer_terms_of_use: 'Условия использования',
    footer_privacy: 'Конфиденциальность',
    footer_legal: 'Юридическая информация',
    footer_contact: 'Контакты',
    footer_company: 'INFINITY-GZ LLC — Sharjah Media City (SHAMS), UAE',
    auth_login_title: 'Вход', auth_register_title: 'Создать аккаунт',
    auth_login_desc: 'Доступ к вашему ресторану', auth_register_desc: 'Запустите ресторан за 2 минуты',
    auth_name_placeholder: 'Ваше имя', auth_restaurant_placeholder: 'Название ресторана',
    auth_email_placeholder: 'Email', auth_password_placeholder: 'Пароль',
    auth_submit_login: 'Войти', auth_submit_register: 'Зарегистрироваться',
    auth_or: 'или', auth_google: 'Продолжить с Google',
    auth_no_account: 'Нет аккаунта?', auth_has_account: 'Уже есть аккаунт?',
    auth_signup_link: 'Зарегистрироваться', auth_login_link: 'Войти',
    auth_fill_all: 'Заполните все поля', auth_success_login: 'Успешный вход!', auth_success_register: 'Аккаунт создан!',
    auth_error: 'Ошибка подключения', auth_google_soon: 'Google Login скоро будет доступен',
    auth_forgot_title: 'Забыли пароль', auth_forgot_desc: 'Введите email, мы отправим ссылку для сброса.', auth_forgot_link: 'Забыли пароль?', auth_forgot_submit: 'Отправить ссылку',
    auth_reset_sent: 'Если email существует, ссылка для сброса была отправлена.', auth_back_login: 'Назад к входу',
    auth_reset_title: 'Новый пароль', auth_reset_desc: 'Выберите новый пароль.', auth_reset_new_password: 'Новый пароль', auth_reset_confirm_password: 'Подтвердите пароль',
    auth_reset_submit: 'Сбросить пароль', auth_reset_mismatch: 'Пароли не совпадают', auth_reset_min_length: 'Минимум 6 символов',
    auth_reset_success: 'Пароль успешно изменен!', auth_reset_error: 'Недействительная или просроченная ссылка', auth_reset_invalid: 'Недействительная ссылка сброса.',
    auth_reset_done_title: 'Пароль изменен!', auth_reset_done_desc: 'Теперь вы можете войти с новым паролем.',
    auth_referral_banner: 'Вы получили приглашение! Подпишитесь и получите 1 бесплатный месяц для обоих.',
  },
  de: {
    nav_features: 'Funktionen', nav_pricing: 'Preise', nav_login: 'Anmelden', nav_signup: 'Kostenlos testen',
    hero_badge: 'Neu: Grab Integration + Buchhaltung',
    hero_title_1: 'Ihr Restaurant', hero_title_2: 'verdient Besseres', hero_title_3: 'als eine Kasse',
    hero_desc: 'Smartes POS mit QR-Menu, Echtzeit-Kuche, integrierter Buchhaltung und Lieferintegration. Alles in einer App.',
    hero_cta: 'Kostenlos starten', hero_discover: 'Entdecken',
    stat_languages: 'Sprachen', stat_install: 'Einrichtung', stat_commission: 'Provision',
    features_title: 'Alles in einem fur Ihr Restaurant',
    features_subtitle: 'Vom digitalen Menu zur Buchhaltung — jede Funktion vereinfacht Ihren Alltag.',
    feat_qr_title: 'Digitales QR-Menu', feat_qr_desc: 'Kunden scannen, bestellen und bezahlen vom Handy. 8 Sprachen.',
    feat_pos_title: 'Touch-POS fur Kellner', feat_pos_desc: 'Optimiert fur 15"-Touchscreens. Schnelle Bestellung, geteilte Rechnung, Trinkgeld.',
    feat_kitchen_title: 'Kuche & Bar', feat_kitchen_desc: 'Dual-Bildschirm in Echtzeit. Kuche und Bar empfangen und bestatigen unabhangig.',
    feat_grab_title: 'Grab Integration', feat_grab_desc: 'Grab-Bestellungen direkt erfassen. Automatische getrennte Buchhaltung.',
    feat_accounting_title: 'Buchhaltung', feat_accounting_desc: 'Umsatz, Margen, Trinkgeld, Aufschlusselung. CSV- und PDF-Export.',
    feat_lang_title: '8 Sprachen', feat_lang_desc: 'Menu automatisch in 8 Sprachen ubersetzt.',
    feat_notif_title: 'Push-Benachrichtigungen', feat_notif_desc: 'Echtzeit-Alerts fur Kellner, Kuche und Kunden.',
    feat_pay_title: 'Flexible Zahlungen', feat_pay_desc: 'Bargeld, Karte, Stripe online. Geteilte Rechnung pro Artikel.',
    steps_title: 'In 3 Schritten einsatzbereit',
    step_1_title: 'Registrieren', step_1_desc: 'Konto erstellen und Restaurant in 2 Minuten einrichten.',
    step_2_title: 'Menu hinzufugen', step_2_desc: 'Gerichte, Preise und Fotos importieren. Auto-Ubersetzung in 8 Sprachen.',
    step_3_title: 'Service starten', step_3_desc: 'QR-Codes generieren, Kellner verbinden sich und Bestellungen kommen rein.',
    pricing_title: 'Einfache und transparente Preise', pricing_subtitle: '14 Tage kostenlos, ohne Verpflichtung.',
    popular_badge: 'Beliebt',
    plan_starter_name: 'Starter', plan_starter_desc: 'Ideal zum Starten',
    plan_pro_name: 'Pro', plan_pro_desc: 'Fur ambitionierte Restaurants',
    plan_enterprise_name: 'Enterprise', plan_enterprise_desc: 'Komplettlosung ohne Grenzen',
    plan_starter_cta: '14 Tage kostenlos', plan_pro_cta: '14 Tage kostenlos', plan_enterprise_cta: 'Kontaktieren Sie uns',
    plan_per_month: '/Monat',
    pf_tables_5: '5 Tische', pf_servers_2: '2 Kellner', pf_qr_menu: 'Digitales QR-Menu', pf_realtime: 'Echtzeit-Bestellungen', pf_cash_card: 'Bargeld & Karte', pf_kitchen_bar: 'Kuche & Bar', pf_email_support: 'Email-Support',
    pf_tables_20: '20 Tische', pf_servers_10: '10 Kellner', pf_all_starter: 'Alles aus Starter +', pf_grab: 'Grab Integration', pf_accounting: 'Buchhaltung & CSV/PDF Export', pf_promo: 'Rabattcodes & Happy Hour', pf_loyalty: 'Treueprogramm', pf_push: 'Push-Benachrichtigungen', pf_priority_support: 'Prioritats-Support',
    pf_unlimited_tables: 'Unbegrenzte Tische', pf_unlimited_servers: 'Unbegrenzte Kellner', pf_all_pro: 'Alles aus Pro +', pf_multi_restaurant: 'Multi-Restaurant', pf_branding: 'Markenanpassung', pf_api: 'API-Zugang', pf_printer: 'Thermodrucker', pf_onboarding: 'Onboarding', pf_247_support: '24/7 Support',
    testimonial_text: '"Wir haben Loyverse ersetzt und gehen nicht zuruck. Die Kuche erhalt Bestellungen in Echtzeit, Kellner sind autonom, Buchhaltung ist jeden Monat bereit."',
    testimonial_author: '— Restaurant HIBISUN, Phuket, Thailand',
    cta_title: 'Bereit, Ihr Restaurant zu modernisieren?', cta_subtitle: '14 Tage kostenlos. Keine Kreditkarte erforderlich.', cta_btn: 'Jetzt starten',
    footer_secure: 'Sichere & verschlusselte Daten',
    footer_terms: 'AGB',
    footer_terms_of_use: 'Nutzungsbedingungen',
    footer_privacy: 'Datenschutz',
    footer_legal: 'Impressum',
    footer_contact: 'Kontakt',
    footer_company: 'INFINITY-GZ LLC — Sharjah Media City (SHAMS), UAE',
    auth_login_title: 'Anmelden', auth_register_title: 'Konto erstellen',
    auth_login_desc: 'Zugang zu Ihrem Restaurant', auth_register_desc: 'Restaurant in 2 Minuten starten',
    auth_name_placeholder: 'Ihr Name', auth_restaurant_placeholder: 'Restaurantname',
    auth_email_placeholder: 'Email', auth_password_placeholder: 'Passwort',
    auth_submit_login: 'Anmelden', auth_submit_register: 'Registrieren',
    auth_or: 'oder', auth_google: 'Weiter mit Google',
    auth_no_account: 'Noch kein Konto?', auth_has_account: 'Bereits ein Konto?',
    auth_signup_link: 'Registrieren', auth_login_link: 'Anmelden',
    auth_fill_all: 'Alle Felder ausfullen', auth_success_login: 'Erfolgreich angemeldet!', auth_success_register: 'Konto erstellt!',
    auth_error: 'Verbindungsfehler', auth_google_soon: 'Google Login kommt bald',
    auth_forgot_title: 'Passwort vergessen', auth_forgot_desc: 'Geben Sie Ihre E-Mail ein, wir senden Ihnen einen Reset-Link.', auth_forgot_link: 'Passwort vergessen?', auth_forgot_submit: 'Link senden',
    auth_reset_sent: 'Falls diese E-Mail existiert, wurde ein Reset-Link gesendet.', auth_back_login: 'Zuruck zur Anmeldung',
    auth_reset_title: 'Neues Passwort', auth_reset_desc: 'Wahlen Sie Ihr neues Passwort.', auth_reset_new_password: 'Neues Passwort', auth_reset_confirm_password: 'Passwort bestatigen',
    auth_reset_submit: 'Passwort zurucksetzen', auth_reset_mismatch: 'Passworter stimmen nicht uberein', auth_reset_min_length: 'Mindestens 6 Zeichen',
    auth_reset_success: 'Passwort erfolgreich geandert!', auth_reset_error: 'Ungultiger oder abgelaufener Link', auth_reset_invalid: 'Ungultiger Reset-Link.',
    auth_reset_done_title: 'Passwort geandert!', auth_reset_done_desc: 'Sie konnen sich jetzt mit Ihrem neuen Passwort anmelden.',
    auth_referral_banner: 'Sie wurden eingeladen! Abonnieren Sie und erhalten Sie 1 kostenlosen Monat fur beide.',
  },
  es: {
    nav_features: 'Funciones', nav_pricing: 'Precios', nav_login: 'Iniciar sesion', nav_signup: 'Prueba gratis',
    hero_badge: 'Nuevo: Integracion Grab + Contabilidad',
    hero_title_1: 'Tu restaurante', hero_title_2: 'merece algo mejor', hero_title_3: 'que una caja',
    hero_desc: 'POS inteligente con menu QR, cocina en tiempo real, contabilidad integrada e integracion de delivery. Todo en una app.',
    hero_cta: 'Empezar gratis', hero_discover: 'Descubrir',
    stat_languages: 'Idiomas', stat_install: 'Instalacion', stat_commission: 'Comision',
    features_title: 'Todo en uno para tu restaurante',
    features_subtitle: 'Del menu digital a la contabilidad, cada funcion simplifica tu dia a dia.',
    feat_qr_title: 'Menu QR Digital', feat_qr_desc: 'Tus clientes escanean, piden y pagan desde su telefono. 8 idiomas.',
    feat_pos_title: 'POS Tactil', feat_pos_desc: 'Optimizado para pantallas de 15". Pedidos rapidos, cuenta dividida, propinas.',
    feat_kitchen_title: 'Cocina & Bar', feat_kitchen_desc: 'Doble pantalla en tiempo real. Cocina y bar reciben y validan de forma independiente.',
    feat_grab_title: 'Integracion Grab', feat_grab_desc: 'Ingresa pedidos Grab directamente. Contabilidad separada automatica.',
    feat_accounting_title: 'Contabilidad', feat_accounting_desc: 'Ingresos, margenes, propinas, desglose por fuente. Exportacion CSV y PDF.',
    feat_lang_title: '8 Idiomas', feat_lang_desc: 'Menu traducido automaticamente a 8 idiomas.',
    feat_notif_title: 'Notificaciones Push', feat_notif_desc: 'Alertas en tiempo real para camareros, cocina y clientes.',
    feat_pay_title: 'Pagos Flexibles', feat_pay_desc: 'Efectivo, tarjeta, Stripe online. Cuenta dividida por articulo.',
    steps_title: 'Listo en 3 pasos',
    step_1_title: 'Registrate', step_1_desc: 'Crea tu cuenta y configura tu restaurante en 2 minutos.',
    step_2_title: 'Agrega tu menu', step_2_desc: 'Importa platos, precios y fotos. Traduccion automatica a 8 idiomas.',
    step_3_title: 'Inicia el servicio', step_3_desc: 'Genera tus codigos QR, tus camareros se conectan y llegan los pedidos.',
    pricing_title: 'Precios simples y transparentes', pricing_subtitle: '14 dias de prueba gratis, sin compromiso.',
    popular_badge: 'Popular',
    plan_starter_name: 'Starter', plan_starter_desc: 'Ideal para empezar',
    plan_pro_name: 'Pro', plan_pro_desc: 'Para restaurantes ambiciosos',
    plan_enterprise_name: 'Enterprise', plan_enterprise_desc: 'Solucion completa sin limites',
    plan_starter_cta: '14 dias gratis', plan_pro_cta: '14 dias gratis', plan_enterprise_cta: 'Contactanos',
    plan_per_month: '/mes',
    pf_tables_5: '5 mesas', pf_servers_2: '2 camareros', pf_qr_menu: 'Menu QR digital', pf_realtime: 'Pedidos en tiempo real', pf_cash_card: 'Efectivo & Tarjeta', pf_kitchen_bar: 'Cocina & Bar', pf_email_support: 'Soporte por email',
    pf_tables_20: '20 mesas', pf_servers_10: '10 camareros', pf_all_starter: 'Todo Starter +', pf_grab: 'Integracion Grab', pf_accounting: 'Contabilidad & exportacion CSV/PDF', pf_promo: 'Codigos promo & Happy Hour', pf_loyalty: 'Programa de fidelidad', pf_push: 'Notificaciones push', pf_priority_support: 'Soporte prioritario',
    pf_unlimited_tables: 'Mesas ilimitadas', pf_unlimited_servers: 'Camareros ilimitados', pf_all_pro: 'Todo Pro +', pf_multi_restaurant: 'Multi-restaurante', pf_branding: 'Personalizacion de marca', pf_api: 'Acceso API', pf_printer: 'Impresora termica', pf_onboarding: 'Onboarding dedicado', pf_247_support: 'Soporte 24/7',
    testimonial_text: '"Reemplazamos Loyverse y no volvemos atras. La cocina recibe pedidos en tiempo real, los camareros son autonomos, y la contabilidad esta lista cada mes."',
    testimonial_author: '— Restaurante HIBISUN, Phuket, Tailandia',
    cta_title: 'Listo para modernizar tu restaurante?', cta_subtitle: '14 dias de prueba gratis. Sin tarjeta de credito.', cta_btn: 'Empezar ahora',
    footer_secure: 'Datos seguros y encriptados',
    footer_terms: 'Condiciones de Venta',
    footer_terms_of_use: 'Condiciones de Uso',
    footer_privacy: 'Privacidad',
    footer_legal: 'Aviso Legal',
    footer_contact: 'Contacto',
    footer_company: 'INFINITY-GZ LLC — Sharjah Media City (SHAMS), UAE',
    auth_login_title: 'Iniciar sesion', auth_register_title: 'Crear cuenta',
    auth_login_desc: 'Accede a tu restaurante', auth_register_desc: 'Lanza tu restaurante en 2 minutos',
    auth_name_placeholder: 'Tu nombre', auth_restaurant_placeholder: 'Nombre del restaurante',
    auth_email_placeholder: 'Email', auth_password_placeholder: 'Contrasena',
    auth_submit_login: 'Iniciar sesion', auth_submit_register: 'Registrarse',
    auth_or: 'o', auth_google: 'Continuar con Google',
    auth_no_account: 'No tienes cuenta?', auth_has_account: 'Ya tienes cuenta?',
    auth_signup_link: 'Registrarse', auth_login_link: 'Iniciar sesion',
    auth_fill_all: 'Completa todos los campos', auth_success_login: 'Sesion iniciada!', auth_success_register: 'Cuenta creada!',
    auth_error: 'Error de conexion', auth_google_soon: 'Google Login disponible pronto',
    auth_forgot_title: 'Contrasena olvidada', auth_forgot_desc: 'Ingrese su email, le enviaremos un enlace de restablecimiento.', auth_forgot_link: 'Olvidaste tu contrasena?', auth_forgot_submit: 'Enviar enlace',
    auth_reset_sent: 'Si este email existe, se envio un enlace de restablecimiento.', auth_back_login: 'Volver al inicio de sesion',
    auth_reset_title: 'Nueva contrasena', auth_reset_desc: 'Elija su nueva contrasena.', auth_reset_new_password: 'Nueva contrasena', auth_reset_confirm_password: 'Confirmar contrasena',
    auth_reset_submit: 'Restablecer contrasena', auth_reset_mismatch: 'Las contrasenas no coinciden', auth_reset_min_length: 'Minimo 6 caracteres',
    auth_reset_success: 'Contrasena cambiada con exito!', auth_reset_error: 'Enlace invalido o expirado', auth_reset_invalid: 'Enlace de restablecimiento invalido.',
    auth_reset_done_title: 'Contrasena cambiada!', auth_reset_done_desc: 'Ahora puede iniciar sesion con su nueva contrasena.',
    auth_referral_banner: 'Has sido invitado! Suscribete para obtener 1 mes gratis para ambos.',
  },
  ar: {
    nav_features: 'الميزات', nav_pricing: 'الأسعار', nav_login: 'تسجيل الدخول', nav_signup: 'تجربة مجانية',
    hero_badge: 'جديد: تكامل Grab + المحاسبة',
    hero_title_1: 'مطعمك', hero_title_2: 'يستحق أفضل', hero_title_3: 'من مجرد صندوق',
    hero_desc: 'نظام POS ذكي مع قائمة QR، مطبخ فوري، محاسبة مدمجة وتكامل التوصيل. كل ما يحتاجه مطعمك في تطبيق واحد.',
    hero_cta: 'ابدأ مجاناً', hero_discover: 'اكتشف',
    stat_languages: 'لغة', stat_install: 'التثبيت', stat_commission: 'عمولة',
    features_title: 'الكل في واحد لمطعمك',
    features_subtitle: 'من القائمة الرقمية إلى المحاسبة، كل ميزة مصممة لتبسيط عملك اليومي.',
    feat_qr_title: 'قائمة QR رقمية', feat_qr_desc: 'العملاء يمسحون ويطلبون ويدفعون من هاتفهم. 8 لغات.',
    feat_pos_title: 'POS شاشة لمس', feat_pos_desc: 'محسّن لشاشات 15 بوصة. طلبات سريعة، تقسيم فاتورة، بقشيش.',
    feat_kitchen_title: 'المطبخ والبار', feat_kitchen_desc: 'شاشة مزدوجة في الوقت الفعلي. المطبخ والبار يستقبلان ويؤكدان بشكل مستقل.',
    feat_grab_title: 'تكامل Grab', feat_grab_desc: 'أدخل طلبات Grab مباشرة. محاسبة منفصلة تلقائية.',
    feat_accounting_title: 'المحاسبة', feat_accounting_desc: 'الإيرادات، الهوامش، البقشيش، تفصيل حسب المصدر. تصدير CSV و PDF.',
    feat_lang_title: '8 لغات', feat_lang_desc: 'القائمة مترجمة تلقائياً إلى 8 لغات.',
    feat_notif_title: 'إشعارات فورية', feat_notif_desc: 'تنبيهات فورية للنُدل والمطبخ والعملاء.',
    feat_pay_title: 'دفع مرن', feat_pay_desc: 'نقد، بطاقة، Stripe أونلاين. تقسيم الفاتورة حسب الصنف.',
    steps_title: 'جاهز في 3 خطوات',
    step_1_title: 'سجّل', step_1_desc: 'أنشئ حسابك وجهّز مطعمك في دقيقتين.',
    step_2_title: 'أضف قائمتك', step_2_desc: 'استورد أطباقك وأسعارك وصورك. ترجمة تلقائية إلى 8 لغات.',
    step_3_title: 'ابدأ الخدمة', step_3_desc: 'أنشئ رموز QR، النُدل يتصلون والطلبات تبدأ بالوصول.',
    pricing_title: 'أسعار بسيطة وشفافة', pricing_subtitle: '14 يوم تجربة مجانية، بدون التزام.',
    popular_badge: 'الأكثر شعبية',
    plan_starter_name: 'Starter', plan_starter_desc: 'مثالي للبداية',
    plan_pro_name: 'Pro', plan_pro_desc: 'للمطاعم الطموحة',
    plan_enterprise_name: 'Enterprise', plan_enterprise_desc: 'حل كامل بلا حدود',
    plan_starter_cta: '14 يوم مجاناً', plan_pro_cta: '14 يوم مجاناً', plan_enterprise_cta: 'تواصل معنا',
    plan_per_month: '/شهر',
    pf_tables_5: '5 طاولات', pf_servers_2: '2 نادل', pf_qr_menu: 'قائمة QR رقمية', pf_realtime: 'طلبات فورية', pf_cash_card: 'نقد & بطاقة', pf_kitchen_bar: 'مطبخ & بار', pf_email_support: 'دعم بالبريد',
    pf_tables_20: '20 طاولة', pf_servers_10: '10 نُدل', pf_all_starter: 'كل Starter +', pf_grab: 'تكامل Grab', pf_accounting: 'محاسبة & تصدير CSV/PDF', pf_promo: 'أكواد خصم & Happy Hour', pf_loyalty: 'برنامج ولاء', pf_push: 'إشعارات Push', pf_priority_support: 'دعم أولوية',
    pf_unlimited_tables: 'طاولات غير محدودة', pf_unlimited_servers: 'نُدل غير محدودين', pf_all_pro: 'كل Pro +', pf_multi_restaurant: 'متعدد المطاعم', pf_branding: 'تخصيص العلامة', pf_api: 'وصول API', pf_printer: 'طابعة حرارية', pf_onboarding: 'تهيئة مخصصة', pf_247_support: 'دعم 24/7',
    testimonial_text: '"استبدلنا Loyverse ولن نعود. المطبخ يستقبل الطلبات فورياً، النُدل مستقلون، والمحاسبة جاهزة كل شهر."',
    testimonial_author: '— مطعم HIBISUN، فوكيت، تايلاند',
    cta_title: 'مستعد لتحديث مطعمك؟', cta_subtitle: '14 يوم مجاناً. لا حاجة لبطاقة ائتمان.', cta_btn: 'ابدأ الآن',
    footer_secure: 'بيانات آمنة ومشفرة',
    footer_terms: 'شروط البيع',
    footer_terms_of_use: 'شروط الاستخدام',
    footer_privacy: 'الخصوصية',
    footer_legal: 'إشعار قانوني',
    footer_contact: 'اتصل بنا',
    footer_company: 'INFINITY-GZ LLC — Sharjah Media City (SHAMS), UAE',
    auth_login_title: 'تسجيل الدخول', auth_register_title: 'إنشاء حساب',
    auth_login_desc: 'الوصول إلى مطعمك', auth_register_desc: 'أطلق مطعمك في دقيقتين',
    auth_name_placeholder: 'اسمك', auth_restaurant_placeholder: 'اسم المطعم',
    auth_email_placeholder: 'البريد الإلكتروني', auth_password_placeholder: 'كلمة المرور',
    auth_submit_login: 'تسجيل الدخول', auth_submit_register: 'التسجيل',
    auth_or: 'أو', auth_google: 'المتابعة مع Google',
    auth_no_account: 'ليس لديك حساب؟', auth_has_account: 'لديك حساب بالفعل؟',
    auth_signup_link: 'التسجيل', auth_login_link: 'تسجيل الدخول',
    auth_fill_all: 'املأ جميع الحقول', auth_success_login: 'تم تسجيل الدخول!', auth_success_register: 'تم إنشاء الحساب!',
    auth_error: 'خطأ في الاتصال', auth_google_soon: 'Google Login قريباً',
    auth_forgot_title: 'نسيت كلمة المرور', auth_forgot_desc: 'أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.', auth_forgot_link: 'نسيت كلمة المرور؟', auth_forgot_submit: 'إرسال الرابط',
    auth_reset_sent: 'إذا كان هذا البريد موجوداً، فقد تم إرسال رابط إعادة التعيين.', auth_back_login: 'العودة لتسجيل الدخول',
    auth_reset_title: 'كلمة مرور جديدة', auth_reset_desc: 'اختر كلمة المرور الجديدة.', auth_reset_new_password: 'كلمة مرور جديدة', auth_reset_confirm_password: 'تأكيد كلمة المرور',
    auth_reset_submit: 'إعادة تعيين كلمة المرور', auth_reset_mismatch: 'كلمات المرور غير متطابقة', auth_reset_min_length: '6 أحرف على الأقل',
    auth_reset_success: 'تم تغيير كلمة المرور بنجاح!', auth_reset_error: 'رابط غير صالح أو منتهي الصلاحية', auth_reset_invalid: 'رابط إعادة تعيين غير صالح.',
    auth_reset_done_title: 'تم تغيير كلمة المرور!', auth_reset_done_desc: 'يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.',
    auth_referral_banner: 'لقد تمت دعوتك! اشترك للحصول على شهر مجاني لكليكما.',
  },
  zh: {
    nav_features: '功能', nav_pricing: '价格', nav_login: '登录', nav_signup: '免费试用',
    hero_badge: '新功能：Grab集成 + 会计',
    hero_title_1: '您的餐厅', hero_title_2: '值得更好的', hero_title_3: '不只是收银机',
    hero_desc: '智能POS系统，配备QR菜单、实时厨房、内置会计和配送集成。餐厅所需的一切，尽在一个应用中。',
    hero_cta: '免费开始', hero_discover: '了解更多',
    stat_languages: '种语言', stat_install: '安装', stat_commission: '佣金',
    features_title: '餐厅一站式解决方案',
    features_subtitle: '从数字菜单到会计，每个功能都为简化您的日常运营而设计。',
    feat_qr_title: '数字QR菜单', feat_qr_desc: '客人扫描、点餐、支付，全在手机上完成。支持8种语言。',
    feat_pos_title: '触屏服务员POS', feat_pos_desc: '针对15寸触屏优化。快速点餐、分账、小费。',
    feat_kitchen_title: '厨房 & 吧台', feat_kitchen_desc: '双屏实时显示。厨房和吧台独立接收和确认。',
    feat_grab_title: 'Grab集成', feat_grab_desc: '直接输入Grab订单。自动独立记账。',
    feat_accounting_title: '会计', feat_accounting_desc: '营收、利润、小费、来源分析。CSV和PDF导出。',
    feat_lang_title: '8种语言', feat_lang_desc: '菜单自动翻译成8种语言。',
    feat_notif_title: '推送通知', feat_notif_desc: '服务员、厨房和客人的实时提醒。',
    feat_pay_title: '灵活支付', feat_pay_desc: '现金、刷卡、Stripe在线支付。按项目分账。',
    steps_title: '3步即可开始',
    step_1_title: '注册', step_1_desc: '创建账户，2分钟内设置好餐厅。',
    step_2_title: '添加菜单', step_2_desc: '导入菜品、价格和照片。自动翻译8种语言。',
    step_3_title: '开始营业', step_3_desc: '生成QR码，服务员连接，订单开始进来。',
    pricing_title: '简单透明的价格', pricing_subtitle: '14天免费试用，无承诺。',
    popular_badge: '热门',
    plan_starter_name: 'Starter', plan_starter_desc: '入门之选',
    plan_pro_name: 'Pro', plan_pro_desc: '适合进取型餐厅',
    plan_enterprise_name: 'Enterprise', plan_enterprise_desc: '无限制完整方案',
    plan_starter_cta: '14天免费试用', plan_pro_cta: '14天免费试用', plan_enterprise_cta: '联系我们',
    plan_per_month: '/月',
    pf_tables_5: '5张桌', pf_servers_2: '2位服务员', pf_qr_menu: '数字QR菜单', pf_realtime: '实时订单', pf_cash_card: '现金 & 刷卡', pf_kitchen_bar: '厨房 & 吧台', pf_email_support: '邮件支持',
    pf_tables_20: '20张桌', pf_servers_10: '10位服务员', pf_all_starter: '所有Starter功能 +', pf_grab: 'Grab集成', pf_accounting: '会计 & CSV/PDF导出', pf_promo: '优惠码 & Happy Hour', pf_loyalty: '忠诚计划', pf_push: '推送通知', pf_priority_support: '优先支持',
    pf_unlimited_tables: '无限桌数', pf_unlimited_servers: '无限服务员', pf_all_pro: '所有Pro功能 +', pf_multi_restaurant: '多餐厅', pf_branding: '品牌定制', pf_api: 'API访问', pf_printer: '热敏打印机', pf_onboarding: '专属入职', pf_247_support: '24/7支持',
    testimonial_text: '"我们替换了Loyverse，再也不会回头。厨房实时收到订单，服务员自主运作，会计每月都准备好了。"',
    testimonial_author: '— HIBISUN餐厅，普吉岛，泰国',
    cta_title: '准备好升级您的餐厅了吗？', cta_subtitle: '14天免费试用。无需信用卡。', cta_btn: '立即开始',
    footer_secure: '数据安全加密',
    footer_terms: '销售条款',
    footer_terms_of_use: '使用条款',
    footer_privacy: '隐私政策',
    footer_legal: '法律声明',
    footer_contact: '联系我们',
    footer_company: 'INFINITY-GZ LLC — Sharjah Media City (SHAMS), UAE',
    auth_login_title: '登录', auth_register_title: '创建账户',
    auth_login_desc: '访问您的餐厅', auth_register_desc: '2分钟启动您的餐厅',
    auth_name_placeholder: '您的姓名', auth_restaurant_placeholder: '餐厅名称',
    auth_email_placeholder: '邮箱', auth_password_placeholder: '密码',
    auth_submit_login: '登录', auth_submit_register: '注册',
    auth_or: '或', auth_google: '使用Google继续',
    auth_no_account: '还没有账户？', auth_has_account: '已有账户？',
    auth_signup_link: '注册', auth_login_link: '登录',
    auth_fill_all: '请填写所有字段', auth_success_login: '登录成功！', auth_success_register: '账户创建成功！',
    auth_error: '连接错误', auth_google_soon: 'Google登录即将推出',
    auth_forgot_title: '忘记密码', auth_forgot_desc: '输入您的邮箱，我们将发送重置链接。', auth_forgot_link: '忘记密码？', auth_forgot_submit: '发送重置链接',
    auth_reset_sent: '如果该邮箱存在，重置链接已发送。', auth_back_login: '返回登录',
    auth_reset_title: '新密码', auth_reset_desc: '选择您的新密码。', auth_reset_new_password: '新密码', auth_reset_confirm_password: '确认密码',
    auth_reset_submit: '重置密码', auth_reset_mismatch: '密码不匹配', auth_reset_min_length: '至少6个字符',
    auth_reset_success: '密码修改成功！', auth_reset_error: '无效或过期的链接', auth_reset_invalid: '无效的重置链接。',
    auth_reset_done_title: '密码已更改！', auth_reset_done_desc: '您现在可以使用新密码登录。',
    auth_referral_banner: '您已被邀请！订阅即可双方各获得1个月免费。',
  },
};

export const useLandingT = (language) => {
  const lang = landingTranslations[language] || landingTranslations.en;
  return (key) => lang[key] || landingTranslations.en[key] || key;
};

export default landingTranslations;
